import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {DceJsx, DceJsxRenderer} from "../../../../dce-jsx"
import CalendarMonth from "./utils/CalendarMonth";
import CalendarI18n from "./utils/CalendarI18n";
import CalendarRenderer from "./view/CalendarRenderer";
import MonthRenderer from "./view/MonthRenderer";

interface CalendarProps {
    mondayStart: boolean;
    cacheMonths: number;
}

@Dce("Calendar")
export default class Calendar extends DceComponent<CalendarProps> {

    public static NOW = Date.now();

    private calendar: CalendarRenderer;

    constructor(elem: DceHTMLElement, props: CalendarProps) {
        super(elem, props);


        this.calendar = new CalendarRenderer(this.props.mondayStart, this.props.cacheMonths, elem, CalendarMonth.now());

    }



    defaultProps(): CalendarProps {
        return {
            mondayStart: false,
            cacheMonths: 3
        }
    }
}



